import { Text } from '@modusign/design-system';

import { getFormattedSouthKoreaPhoneNumber } from '@app/libs/inputFormat';

import Contact from '../../../types/Contact';

interface AddressBookSearchInputListItemProps
  extends Pick<Contact, 'name' | 'companyName' | 'phoneNumber' | 'email'> {}

function AddressBookSearchInputListItem({
  companyName,
  email,
  name,
  phoneNumber,
}: AddressBookSearchInputListItemProps) {
  return (
    <>
      <Text as="p" ellipsis fontSize="sm" fontWeight="medium" sx={{ overflowY: 'hidden' }}>
        {name}
      </Text>
      {companyName && (
        <Text
          as="p"
          color="textNeutralVeryLight"
          ellipsis
          fontSize="xs"
          sx={{ overflowY: 'hidden' }}
        >
          {companyName}
        </Text>
      )}
      {phoneNumber && (
        <Text
          as="p"
          color="textNeutralSlightlyLight"
          ellipsis
          fontSize="xs"
          sx={{ overflowY: 'hidden' }}
        >
          {getFormattedSouthKoreaPhoneNumber(phoneNumber)}
        </Text>
      )}
      {email && (
        <Text
          as="p"
          color="textNeutralSlightlyLight"
          ellipsis
          fontSize="xs"
          sx={{ overflowY: 'hidden' }}
        >
          {email}
        </Text>
      )}
    </>
  );
}

export default AddressBookSearchInputListItem;
